import {dataTemplate} from './dataTemplate';

const WeeklyPlan = dataTemplate('weeklyPlan');

export default WeeklyPlan;
